let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("03aeW")).then(() => parcelRequire('9Uzok'));